import defaultLocale from './en';
export default defaultLocale;
export * from './interface';
export { getTransedText } from './getTransedText';